import React from 'react';
import c from 'classnames';
import { SocialLoginProvider } from '../types';
import useFacebookSignIn from '../hooks/useFacebookSignIn';
import SocialButtonBase from '../SocialButtonBase';
import SocialButtonIconViewBase from '../SocialButtonIconViewBase';
import s from './SocialButtonFacebook.scss';
var SocialButtonFacebook = function (_a) {
    var appId = _a.appId, biData = _a.biData, className = _a.className, _b = _a.view, view = _b === void 0 ? 'standard' : _b, _c = _a.redirectToJoin, redirectToJoin = _c === void 0 ? false : _c, redirectToSisu = _a.redirectToSisu, children = _a.children, attemptSocialLogin = _a.attemptSocialLogin;
    var signIn = useFacebookSignIn(appId, function (response) {
        if (response.authResponse) {
            attemptSocialLogin({
                provider: SocialLoginProvider.Facebook,
                token: response.authResponse.accessToken,
                redirectToJoin: redirectToJoin,
                redirectToSisu: redirectToSisu,
            });
        }
    }).signIn;
    var onClick = function (e) {
        e.preventDefault();
        signIn();
    };
    if (view === 'icon') {
        return (React.createElement(SocialButtonIconViewBase, { className: c(s['root'], s['icon'], className), biData: biData, onClick: onClick }));
    }
    return (React.createElement(SocialButtonBase, { className: c(s['root'], className), biData: biData, onClick: onClick }, children));
};
SocialButtonFacebook.displayName = 'SocialButtonFacebook';
export default SocialButtonFacebook;
//# sourceMappingURL=SocialButtonFacebook.js.map